import type React from 'react';

interface AsanaIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function AsanaIcon({ size = 24, ...props }: AsanaIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Asana_logo" clipPath="url(#clip0_17071_188499)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5007 7.81712C10.5819 7.81712 9.02647 9.37264 9.02647 11.2915C9.02647 13.2103 10.5819 14.7658 12.5007 14.7658C14.4195 14.7658 15.975 13.2103 15.975 11.2915C15.975 9.37264 14.4195 7.81712 12.5007 7.81712ZM3.47427 7.81742C1.5555 7.81742 0 9.37264 0 11.2915C0 13.2103 1.5555 14.7658 3.47427 14.7658C5.39311 14.7658 6.94869 13.2103 6.94869 11.2915C6.94869 9.37264 5.39311 7.81742 3.47427 7.81742ZM11.4617 3.47419C11.4617 5.39311 9.90624 6.94877 7.98751 6.94877C6.06864 6.94877 4.51322 5.39311 4.51322 3.47419C4.51322 1.55565 6.06864 0 7.98751 0C9.90624 0 11.4617 1.55565 11.4617 3.47419Z"
          fill="#F06A6A"
        />
      </g>
      <defs>
        <clipPath id="clip0_17071_188499">
          <rect width="16" height="14.8037" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
